import {observable, action, runInAction} from 'mobx'
import alertMessage from '../utils/alertMessage'
import miceCadAPI from '../apis/miceCadAPI'

export default class ReportStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable miceCadUrl = null

  @action
  async getMiceCadUrl(type) {
    this.isFetching = true
    try {
      const response = await miceCadAPI.getMiceCadUrl(type)
      runInAction(() => {
        const {data} = response
        this.isFetching = false
        if (data.code === 0) {
          this.miceCadUrl = data?.data || null
        } else {
          alertMessage.error('Failed！' + data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
}
